/* RESPONSIBLE TEAM: team-phone */
import ForwardCallSerializer from '../step';

export default ForwardCallSerializer;
